import { Injectable } from '@angular/core';
import html2pdf from 'html2pdf.js';

@Injectable({
  providedIn: 'root',
})
export class PdfGenerationService {
  /**
   * Generates a PDF from HTML element
   * @param element - The HTML element to convert
   * @param filename - The name of the PDF file (without extension)
   */
  async generatePdfFromHtml(element: HTMLElement, filename: string = 'document'): Promise<void> {
    const opt = {
      margin: 10,
      filename: `${filename}.pdf`,
      image: { type: 'png' as const, quality: 1 },
      html2canvas: { 
        scale: 4, 
        useCORS: true,
        letterRendering: true,
        scrollY: 0,
        scrollX: 0,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
        logging: false,
        removeContainer: true,
        backgroundColor: '#ffffff'
      },
      jsPDF: { unit: 'mm' as const, format: 'a4' as const, orientation: 'portrait' as const },
      pagebreak: { 
        mode: ['avoid-all', 'css', 'legacy'],
        avoid: ['.sob__grid', '.sob__subgrid', '.sob__benefit', '.sob__category']
      }
    };

    try {
      await html2pdf().set(opt).from(element).save();
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  }

  /**
   * Generates a PDF blob from HTML element (without downloading)
   * @param element - The HTML element to convert
   */
  async generatePdfBlob(element: HTMLElement): Promise<Blob> {
    const opt = {
      margin: 10,
      image: { type: 'png' as const, quality: 1 },
      html2canvas: { 
        scale: 4, 
        useCORS: true,
        letterRendering: true,
        scrollY: 0,
        scrollX: 0,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
        logging: false,
        removeContainer: true,
        backgroundColor: '#ffffff'
      },
      jsPDF: { unit: 'mm' as const, format: 'a4' as const, orientation: 'portrait' as const },
      pagebreak: { 
        mode: ['avoid-all', 'css', 'legacy'],
        avoid: ['.sob__grid', '.sob__subgrid', '.sob__benefit', '.sob__category']
      }
    };

    try {
      const blob = await html2pdf().set(opt).from(element).outputPdf('blob');
      return blob;
    } catch (error) {
      console.error('Error generating PDF blob:', error);
      throw error;
    }
  }
}

